<template>
    <!-- 活动列表页 -->
    <div class="one_Box">
        <div class="title flex">
            <div class="title_t" @click="onBack()">
                <img src="../../../assets/image/one/fanhui.png">
                <span>{{ val }}USD</span>
                <div></div>
            </div>
        </div>

        <div class="goods">
            <div class="goods_box" v-for="el in list" :key="el.id">
                <div class="goods_box_tie">
                    <span>
                      No. {{ el.phase_sn }}
                      <img
                        v-if="el.has_pwd == 1"
                        :src="el.pwd_unlocked ? require('../../../assets/image/one/unlock.png') : require('../../../assets/image/one/lock.png')"
                        width="18px"
                      />
                    </span>
                    <span class="countdown" v-if="el.slots_sold < el.max_slots">{{ formatCountdown(el.remainingTime) }}</span>
                    <span v-else>{{ $t('new24') }}</span>
                </div>
                <div class="goods_box_le">
                    <img :src="el.goods_image">
                    <div class="goods_box_le_text">
                        <div style="flex: 1;"> {{ el.goods_name }}</div>
                        <div style="margin-top: 10px;">{{ $t('yi20') }}<span>{{ el.usd }}usd</span></div>
                    </div>
                </div>
                <div class="goods_box_ri">
                    <p class="progress">
                        <span :style="'width: ' + ((el.slots_sold / el.max_slots) * 100).toFixed(2) + '%'"></span>
                    </p>

                    <div class="goods_box_ri_box 1111">
                        <div>
                            <span>{{ el.slots_sold || 0 }}</span>
                            <p>{{ $t('yi9') }}</p>
                        </div>
                        <div>
                            <span>{{ el.max_slots || 0 }}</span>
                            <p>{{ $t('yi10') }}</p>
                        </div>
                        <div>
                            <span>{{ (Number(el.max_slots) - Number(el.slots_sold)) || 0 }}</span>
                            <p>{{ $t('yi11') }}</p>
                        </div>
                    </div>

                    <div class="goods_box_ri_btn">
                        <div @click="onBuy(el)" v-if="el.slots_sold < el.max_slots"> {{ el.is_buy == 0 ? $t('yi12') : $t('yi13') }}</div>
                        <div v-else class="wait-draw">{{ $t('new24') }}</div>
                    </div>
                </div>
            </div>

            <div class="more" v-if="(page * limit) < goods.total" @click="more">{{ $t('yi15') }}</div>
            <div v-if="list.length <= 0">{{ $t('yi16') }}</div>
        </div>
        <BuyConfirm
        :visible="showBuyConfirm"
        :title="dialogTitle"
        :available_predeposit="memberInfo.available_predeposit"
        :gift_balance="memberInfo.gift_balance"
        :max_slots="max_slots"
        :slots_sold="slots_sold"
        :confirmText="$t('MessageBox.Confirm')"
        :cancelText="$t('MessageBox.Cancel')"
        @confirm="doBuy"
        @cancel="showBuyConfirm = false"
        />
    </div>
</template>

<script>
import { Dialog } from 'vant';
import { Buy, UsdActivityList, CheckPassword } from '../../../api/memberOne';
import BuyConfirm from '@/components/BuyConfirm.vue';
import { getMemberIndex } from '../../../api/member';
import { Indicator, Toast, MessageBox } from "mint-ui";
import { loadValidatedPasswords,saveValidatedPasswords } from '../../../util/common'
export default {
  components: { BuyConfirm },
  props: {
    val: {
      type: [String, Number, Object],
      default: ''
    },
    valAct: {
      type: [String, Number, Object],
      default: ''
    },
  },
  data() {
    return {
      showBuyConfirm: false,
      dialogTitle: '',
      memberInfo: {},
      max_slots: 0,
      page: 1,
      limit: 10,
      goods: [],
      list: [],
      intervalId: null,
      activity_id: 0,
      phase_sn: '',
      password: '',
      slots_sold: 0,
      refreshing: false,
      validatedPasswords: loadValidatedPasswords(),
    };
  },
  created() {
    this.getUsdActivityList();
    this.startCountdown();
  },
  mounted() {
    this.getBalance();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId)
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    // 获取余额
    getBalance() {
      getMemberIndex().then(
        response => {
          if (response && response.result.member_info) {
            this.memberInfo = response.result.member_info;
          }
        }
      );
    },
    // 点击购买
    onBuy(obj) {
      const cached = this.validatedPasswords[obj.id];
      if (obj.has_pwd) {
        if (cached && cached.expires_at > Date.now()) {
          obj.password = cached.password;
          obj.pwd_unlocked = true;
          this.onBuyConfirm(obj);
        } else {
          this.onPassword(obj);
        }
      } else {
        this.onBuyConfirm(obj);
      }
    },
    onBuyConfirm(obj) {
      if(obj.password){
        this.password = obj.password;
      }
      this.activity_id = obj.id;
      this.dialogTitle = 'No. '+obj.phase_sn
      this.max_slots = obj.max_slots;
      this.slots_sold = obj.slots_sold;
      this.showBuyConfirm = true;
    },
    // 购买请求接口
    doBuy(pay_type, buy_nums) {
      Indicator.open()
      Buy({ activity_id: this.activity_id, buy_nums, pay_type, password: this.password }, 'one').then(res => {
        if (res.code === 10000) {
          this.onUpdateSlotsSold({ activity_id: this.activity_id, buy_nums });
          this.getBalance();
          this.showBuyConfirm = false;
        }
        Indicator.close()
        Dialog.alert({ message: res.message, confirmButtonText: this.$t('MessageBox.Confirm') });
      });
    },
    // 输入密码
    onPassword(obj) {
      let that = this;
      MessageBox({
        $type: "prompt",
        title: '',
        message: that.$t("Enter Password"),
        confirmButtonText: that.$t("MessageBox.Confirm"),
        cancelButtonText: that.$t("MessageBox.Cancel"),
        showCancelButton: true,
        showInput: true,
        confirmButtonClass: "confirm_box",
        cancelButtonClass: "cancel_box",
      }).then(({ value, action }) => {
          if (action == "confirm") {
            CheckPassword({ activity_id: obj.id, password: value })
              .then((res) => {
                if (res.code == 10000) {
                  const expireAt = Date.now() + 24 * 60 * 60 * 1000; // 24小时
                  obj.password = value;
                  obj.pwd_unlocked = true;

                  this.validatedPasswords[obj.id] = {
                    password: value,
                    expires_at: expireAt
                  };
                  saveValidatedPasswords(this.validatedPasswords);

                  this.onBuyConfirm(obj);
                } else {
                  Toast(res.message);
                }
              })
          }
        }).catch(() => {});
    },
    // 返回上一页
    onBack() {
      if(this.valAct == 'usd_page'){
        this.onPage('usd_page')
      }else{
        this.onPage('index')
      }
    },
    onPage(v, val) {
      if(v == 'usd_page'){
        this.$emit('onPage', v, val, 'usd_page')
      }else{
        this.$emit('onPage', v, val)
      }
    },
    // 上拉加载更多
    more() {
      this.page++;
      this.getUsdActivityList();
    },
    // 获取活动列表
    getUsdActivityList(reset = false) {
      const { val, page, limit } = this;
      if (this.refreshing) return;

      this.refreshing = true;
      UsdActivityList({ usd: val, page, limit }, 'one')
        .then(res => {
          if (res && res.result) {
            this.goods = res.result;
            const newList = res.result.data.map(item => ({
              ...item,
              remainingTime: item.deadline_time,
              pwd_unlocked: this.validatedPasswords[item.id] ? true : false // 回填解锁状态
            }));
            this.list = reset ? newList : [...this.list, ...newList];
          }
        })
        .finally(() => {
          this.refreshing = false;
        });
    },

    // 倒计时逻辑
    startCountdown() {
      this.intervalId = setInterval(() => {
        let needRefresh = false;
        this.list = this.list.map(item => {
          const nextTime = Math.max(0, item.remainingTime - 1);
          if (nextTime === 0 && item.remainingTime > 0) {
            needRefresh = true;
          }
          return { ...item, remainingTime: nextTime };
        });
        if (needRefresh) {
          this.page = 1;
          if(this.showBuyConfirm) this.showBuyConfirm = false;
          this.getUsdActivityList(true)
        }
      }, 1000);
    },
    // 格式化倒计时
    formatCountdown(timeLeftInSeconds) {
        if (timeLeftInSeconds <= 0) {
            return this.$t('Next event loading')+'...';
        }
      let timeLeft = timeLeftInSeconds * 1000;
      timeLeft = Math.max(0, timeLeft);
      const hours = String(Math.floor(timeLeft / (1000 * 60 * 60))).padStart(2, '0');
      const minutes = String(Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
      const seconds = String(Math.floor((timeLeft % (1000 * 60)) / 1000)).padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
    },
    // 更新已购买的数量
    onUpdateSlotsSold(data) {
      const index = this.list.findIndex(item => item.id === data.activity_id);
      if (index !== -1) {
        let slots_sold_new_nums = 0
        if(data.buy_nums){
          slots_sold_new_nums = this.list[index].slots_sold + data.buy_nums;
        }else{
          slots_sold_new_nums = data.slots_sold
        }
        const updated = {
          ...this.list[index],
          slots_sold: slots_sold_new_nums
        };
        this.$set(this.list, index, updated);
      }
    },
    handleVisibilityChange() {
        if (document.visibilityState === 'visible') {
            // 页面重新变为可见时执行
            this.getUsdActivityList(true)
            if (this.showBuyConfirm) this.showBuyConfirm = false
        }
    }
  }
};
</script>

<style scoped lang="scss">
.flex {
    display: flex;
}
.wait-draw{
    color: #5f3636;
    background: unset;
    border: 1px #E8090C solid;
}
.one_Box {
    overflow-y: auto;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .title {
        align-items: center;
        justify-content: space-between;

        .title_t {
            font-size: 14px;
            color: #000;
            font-weight: bold;
            display: flex;
            align-items: center;
            position: relative;
            cursor: pointer;

            img {
                margin-right: 5px;
                width: 8px;
                height: 14px;
            }

            div {
                position: absolute;
                left: 0;
                bottom: -5px;
                width: 100%;
                height: 5px;
                background: linear-gradient(90deg, #F21D19 0%, #FFF5F4 100%);
                border-radius: 8px;
            }
        }

        .title_x {
            cursor: pointer;

            svg {
                width: 20px;
                height: 20px;
            }
        }
    }

    .goods::-webkit-scrollbar {
        display: none;
    }
    .goods {
        flex: 1;
        overflow-y: auto;
        margin: 20px 0 0;
        scrollbar-width: none;
        -ms-overflow-style: none;
        padding-bottom: 100px;

        .goods_box {
            display: flex;
            padding: 10px;
            box-sizing: border-box;
            margin-bottom: 10px;
            border-radius: 8px;
            border: 1px solid #F45C1D;
            background: linear-gradient(-32deg, #FFE8E0 0%, #FFFAF9 100%);
            display: flex;
            flex-direction: column;

            .goods_box_tie {
                color: #666666;
                font-size: 12px;
                margin-bottom: 10px;
                display: flex;
                justify-content: space-between;
                .countdown{color:#E8090C;}
            }

            .goods_box_le {
                img {
                    width: 100px;
                    height: 58px;
                    margin-bottom: 5px;
                    margin-right: 15px;
                    object-fit: contain;
                    border: 1px solid #ccc;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    border-radius: 5px;
                    background: #fff;
                }

                display: flex;

                .goods_box_le_text {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;

                    div:nth-child(1) {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        -webkit-line-clamp: 3;
                        line-height: 12px;
                    }

                    div:nth-child(2) {
                        padding-bottom: 10px;
                        box-sizing: border-box;
                    }

                    span {
                        color: #EA190F;
                        font-size: 12px;
                    }
                }

                font-size: 12px;
            }

            .goods_box_ri {
                margin-top: 5px;
                flex: 1;
                display: flex;
                flex-direction: column;

                .progress {
                    height: 8px;
                    background: #c10714;
                    border: 1px solid #DBDBDB;
                    position: relative;
                    border-radius: 8px;

                    span {
                        height: 10px;
                        background: url('../../../assets/image/one/Announced_4A.gif') center center repeat-x;
                        position: absolute;
                        top: -1px;
                        left: -1px;
                        font-size: 0;
                        border-radius: 8px;
                    }
                }

                .goods_box_ri_box {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    font-size: 12px;
                    flex: 1;
                    margin-top: 10px;
                    text-align: center;
                }

                .goods_box_ri_btn {
                    padding: 20px 20px 10px;
                    box-sizing: border-box;

                    div {
                        cursor: pointer;
                        width: 100%;
                        margin: 10px auto 0;
                        background: linear-gradient(90deg, #E8090C 0%, #F3611E 100%);
                        border-radius: 22px;
                        color: #fff;
                        font-size: 12px;
                        padding: 10px 0px;
                        text-align: center;
                    }
                }
            }
        }

        .more {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            text-align: center;
            height: 30px;
            border-radius: 20px;
            border: 1px solid #FE3421;
            font-size: 16px;
            color: #FE3421;
        }
    }

    .more {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 99%;
        text-align: center;
        height: 30px;
        border-radius: 20px;
        border: 1px solid #FE3421;
        font-size: 16px;
        color: #FE3421;
    }
}
</style>